export const START_DATE_OFFSET_MONTHS_FROM_TODAY = 24

export const RATE = {
  MIN: 0,
  MAX: 5,
}
